import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";

const PageTransition = ({ children }) => {
  const location = useLocation();
  const isFirstMount = useRef(true);
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }

    setIsNavigating(true);
    const timer = setTimeout(() => {
      setIsNavigating(false);
    }, 600);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {/* ── Prominent Golden Header Energy Streak ── */}
      <AnimatePresence>
        {isNavigating && (
          <motion.div
            key={`energy-streak-${location.pathname}`}
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.25, ease: "easeOut" } }}
            className="fixed top-0 left-0 right-0 z-[999999] pointer-events-none"
            style={{ height: "4px" }}
          >
            {/* The Main Glowing Bar */}
            <motion.div
              initial={{ width: "0%" }}
              animate={{ width: ["0%", "65%", "100%"] }}
              transition={{
                duration: 0.55,
                times: [0, 0.45, 1],
                ease: [0.16, 1, 0.3, 1],
              }}
              className="relative h-full"
              style={{
                background: "linear-gradient(90deg, #E97818 0%, #F29A0C 45%, #FFD166 85%, #FFFFFF 100%)",
                boxShadow: "0 0 16px rgba(242, 154, 12, 0.95), 0 0 8px rgba(255, 209, 102, 0.8), 0 2px 4px rgba(0,0,0,0.25)",
              }}
            >
              {/* Glowing Leading Head Light Orb */}
              <div
                className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rounded-full pointer-events-none"
                style={{
                  width: "10px",
                  height: "10px",
                  background: "#FFFFFF",
                  boxShadow: "0 0 12px #FFFFFF, 0 0 20px #FFD166, 0 0 30px #F29A0C",
                }}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main Page Content */}
      {children}
    </>
  );
};

export default PageTransition;
